import { render, staticRenderFns } from "./btn-with-loader.vue?vue&type=template&id=62821e9d&scoped=true&"
import script from "./btn-with-loader.vue?vue&type=script&lang=js&"
export * from "./btn-with-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62821e9d",
  null
  
)

export default component.exports